export default __webpack_public_path__ + "static/media/bar-chart.57757d86.svg";